import SubmitButton from '@/components/ui/SubmitButton';
interface DeleteModalProps {
  onCancel: () => void;
  deleteId: string;
  onConfirm: (id: string) => void | Promise<void>;
  text?: string;
  subText?: string;
  phrase?: string;
  isDeleating?: boolean;
}

const DeleteModal = ({
  onCancel,
  onConfirm,
  deleteId,
  text = ' Are you sure you want to permanently delete',
  subText = 'Account ?',
  phrase,
  isDeleating,
}: DeleteModalProps) => {
  return (
    <div className="px-5 flex flex-col gap-5">
      <p className="text-textcolor">
        {text} <span className="font-semibold">{phrase ?? subText}</span>{' '}
      </p>
      <div className="flex justify-end gap-4 border-t pt-2 font-medium">
        <button
          className="px-6 py-2 rounded-lg border border-green text-textcolor transition"
          onClick={onCancel}
        >
          Cancel
        </button>
        <SubmitButton disabled={isDeleating} onClick={() => deleteId && onConfirm(deleteId)}>
          Confirm
        </SubmitButton>
      </div>
    </div>
  );
};

export default DeleteModal;
